import { DEFAULT_APP_CURRENCY } from 'constants/constants';
import { TYPE_OF_ORDER_TITLES } from 'widgets/CaseManagement/TypeOfOrder/TypeOfOrder';

export const adaptCreateCasePayload = ({ payload = {} }: { payload: any }) => {
    const {
        contactId,
        portfolioId,
        investmentApplicationId,
        investedAmount,
        typeOfOrderData,
        reasonForSaleData,
        bankInformationData,
        isPOA, isPK,
        isPaymentOrderPrivateAccount,
        isEmailRetention,
    } = payload;

    return {
        ContactId: contactId,
        PortfolioId: +portfolioId,
        InvestmentApplicationId: +investmentApplicationId,
        OrderTypeId: +typeOfOrderData?.OrderTypeId,
        Amount: typeOfOrderData?.Amount,
        ...(!isPaymentOrderPrivateAccount && { ReasonListItemId: +reasonForSaleData?.ReasonListItemId, ReasonText: reasonForSaleData?.ReasonText }),
        IsEmailRetention: isEmailRetention,
        InvestedAmount: investedAmount,
        BankInformation: {
            PayoutTargetListItemId: +bankInformationData?.bankAccountOption,
            BeneficiaryInformation: {
                FirstName: bankInformationData?.firstName,
                LastName: bankInformationData?.lastName,
                Address: bankInformationData?.address,
                ZipCode: bankInformationData?.zipCodeOfBeneficiary,
                City: bankInformationData?.cityOfBeneficiary,
            },
            AccountDetails: {
                Iban: bankInformationData?.iban,
                Esr: bankInformationData?.esr,
                BankName: bankInformationData?.bankName,
                ZipCode: bankInformationData?.zipCode,
                City: bankInformationData?.city,
                Message1: bankInformationData?.messageText1,
                ...(isPaymentOrderPrivateAccount && { Message2: bankInformationData?.messageText2 }),
            },
        },
        IsInitiatedByPoA: isPOA,
        PrivateAccount: isPK ? {
            NeedCloseAccount: typeOfOrderData?.NeedCloseAccount || false,
            PayIssueCommission: bankInformationData?.subscriptionFeeConsideration?.[0] || false,
        } : null,
    };
};

export const adaptSummaryUIData = ({
    currentPortfolioSelector,
    typeOfOrderData,
    reasonForSaleData,
    bankInformationData,
    reasonForSaleOptions,
    t,
    getFormattedCurrency,
    active3bPortfolioOptions,
}) => ({
    isPartialSale: +typeOfOrderData?.OrderTypeId === 1,
    orderType: t(TYPE_OF_ORDER_TITLES?.[typeOfOrderData?.OrderTypeId]),
    productName: `${currentPortfolioSelector?.Product?.Description} - ${currentPortfolioSelector?.ModelPortfolioName}`,
    currentInvestmentAmount: getFormattedCurrency(currentPortfolioSelector?.CurrentValue || 0, {
        currency: DEFAULT_APP_CURRENCY,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        signDisplay: 'never',
    }),
    withdrawalAmount: getFormattedCurrency(typeOfOrderData?.Amount || 0, {
        currency: DEFAULT_APP_CURRENCY,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        signDisplay: 'never',
    }),
    remainingInvestmentAmount: getFormattedCurrency(((currentPortfolioSelector?.CurrentValue || 0) - typeOfOrderData?.Amount), {
        currency: DEFAULT_APP_CURRENCY,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        signDisplay: 'never',
    }),
    reasonForSale: reasonForSaleOptions?.find(option => option?.value === reasonForSaleData?.ReasonListItemId)?.label || '',
    reasonForSaleText: reasonForSaleData?.ReasonText || '',
    beneficiaryFullName: (`${bankInformationData?.firstName} ${bankInformationData?.lastName}`) || '',
    beneficiaryAddress: bankInformationData?.address || '',
    beneficiaryZipAndCity: `${bankInformationData?.zipCodeOfBeneficiary} ${bankInformationData?.cityOfBeneficiary}`,
    depotTitle: active3bPortfolioOptions?.find(option => option?.value === bankInformationData?.zurichInvestDepotAccount)?.label,
    iban: bankInformationData?.iban,
    esr: bankInformationData?.esr,
    bankName: `${bankInformationData?.bankName}, ${bankInformationData?.zipCode} ${bankInformationData?.city}`,
    message1: bankInformationData?.messageText1,
    message2: bankInformationData?.messageText2,
    subscriptionFeeConsideration: bankInformationData?.subscriptionFeeConsideration?.[0],
    subscriptionFeeConsiderationText: bankInformationData?.subscriptionFeeConsideration?.[0] ? t('clientDashboard.yes') : t('clientDashboard.no'),
});
